<app-loading *ngIf="loading" [isOverlay]="true"></app-loading>

<section id="body" class="wo-print-page pt-3 container-fluid" dir="auto" *ngIf="!loading && workorder">
    <header *ngIf="isElSalamUrl" class="elsalam-report-header">
        <img src="assets/logo/ElSalamHeader.jpg" alt="El Salam Facilities Management" class="elsalam-report-banner" />
    </header>
    <div *ngIf="!isElSalamUrl" class="print-logo-container d-flex justify-content-start bg-white mx-auto w-100">
        <img [src]="CompanyLogo" alt="Company Logo" class="print-logo" />
    </div>
    <div class="form-container">
      <h1>{{ 'Reports.MAINTENANCE_ORDER_FORM' | translate}}</h1>
      
      <!-- First Row -->
      <table>
          <tr>
              <td class="label col-4">{{ 'Reports.SERVICE_REQUEST_NUMBER' | translate }}</td>
              <td class="input-cell col-4">{{ workorder.serviceRequestNumber  }}</td>
              <td class="label col-4">{{ 'Reports.WORK_ORDER_NUMBER' | translate }}</td>
              <td class="input-cell col-4">{{ workorder.workOrderNumber   }}</td>
          </tr>
      </table>
      
      <!-- Second Row -->
        <div class="table-row">
              <table>
                  <tr>
                      <td class="label col-2">{{ 'Reports.DATE' | translate }}</td>
                      <td class="input-cell col-2">{{ (workorder.date | date : 'dd-MM-yyyy') }}</td>
                  </tr>
              </table>
              <table>
                  <tr>
                      <td class="label col-2">{{ 'Reports.STATE' | translate }}</td>
                      <td class="input-cell">{{ workorder.client?.stateName }}</td>
                    </tr>
                    <tr>
                      <td class="label col-2">{{ 'Reports.clientName' | translate }}</td>
                      <td class="input-cell">{{ workorder.client?.mainClient }} - {{ workorder.client?.name }}</td>
                  </tr>
              </table>
          </div>
      
      <!-- Third Row -->
      <table>
          <tr>
              <td class="label col-2">{{ 'Reports.SERVICE_CATEGORY' | translate }}</td>
              <td class="label col-2">{{ 'Reports.MALFUNCTION' | translate }}</td>
          </tr>
          <tr>
              <td class="input-cell">{{ workorder.serviceCategoryParent }}</td>
              <td class="input-cell">{{ workorder.serviceCategory }}</td>
          </tr>
      </table>
      
      <!-- Fourth Row -->
      <table>
          <tr>
              <td class="label col-2">{{ 'Reports.REPORTNOTES' | translate }}</td>
              <td class="input-cell col-2">{{ workorder.serviceRequestNotes  }}</td>
          </tr>
      </table>
      
      <div class="section-title">{{'Reports.WorksReport'|translate}}</div>
      <div class="section-title mb-10">{{ status     }}</div>
      
      <!-- Fifth Row -->
      <table>
          <tr>
              <td class="label">{{ 'Reports.malfunctionNotes' | translate }}</td>
              <td class="input-cell">{{ workorder.workReportDescription     }}</td>
          </tr>
      </table>
      
      <div *ngIf="sparePartsList.length > 0" class="section-title">{{'Reports.SpareParts' | translate}}</div>
      
      <!-- Spare Parts Table -->
      <table *ngIf="sparePartsList.length > 0">
          <tr>
              <td class="label col-3">{{'Reports.CODE' | translate}}</td>
              <td class="label col-3">{{ 'Reports.NAME' | translate }}</td>
              <td class="label col-3">{{ 'Reports.QUANTITY' | translate }}</td>
          </tr>
          <tr *ngFor="let part of sparePartsList">
            <td class="input-cell">{{part.code}}</td>
            <td class="input-cell">{{part.name}}</td>
            <td class="input-cell">{{part.quantity}}</td>
          </tr>
      </table>
      
      <div class="section-title">{{'Reports.WORK_EXECUTOR' | translate}}</div>
      
      <!-- Work Executor Table -->
      <table>
          <tr>
              <td class="label col-2">{{'Reports.Assigned_Type' | translate}}</td>
              <td class="label col-2">{{'Reports.Supervisor' | translate}}</td>
          </tr>
          <tr>
              <td class="input-cell">{{ workorder.assignedTechnician?.name || workorder.assignedTeam?.name      }}</td>
              <td class="input-cell"></td>
          </tr>
      </table>
      
      <div class="section-title">{{'Reports.CLIENT_MANAGER' | translate}}</div>
      
      <!-- Client Representative Table -->
      <table>
          <tr>
              <td class="label col-2">{{'Reports.NAME' | translate}}</td>
              <td class="label col-2">{{'Reports.PHONENUM' | translate}}</td>
          </tr>
          <tr>
              <td class="input-cell col-2">{{ workorder.client?.responsibleName     }}</td>
              <td class="input-cell col-2">{{ workorder.client?.mobile     }}</td>
          </tr>
          <tr>
              <td class="label col-2">{{ 'Reports.SIGNATURE' | translate }}</td>
              <td class="label col-2">{{'Reports.seal' | translate}}</td>
          </tr>
          <tr>
              <td class="input-cell" style="height: 60px;"></td>
              <td class="input-cell" style="height: 60px;"></td>
          </tr>
      </table>
    </div>

    <footer *ngIf="isElSalamUrl" class="elsalam-report-footer">
        <img src="assets/logo/ElSalamFooter.jpg" alt="El Salam contact" class="elsalam-report-banner" />
    </footer>

        <div class="print-sticky-btn">
            <app-button
                [hidden]="BtnPrint"
                [full]="false"
                [tone]="'primary'"
                [impact]="'bold'"
                [size]="'medium'"
                [shape]="'rounded'"
                [shadow]="'none'"
                [disabled]="false"
                [type]="'button'"
                (buttonClick)="SavePDf()"
                style="width: 80px"
            >
                {{ 'Reports.PRINT' | translate }}
            </app-button>
        </div>
</section>

<section id="no-data" class="wo-print-page pt-5 container-fluid wo-empty-state" dir="auto" *ngIf="!loading && !workorder">
    <div class="wo-empty-wrapper">
        <div class="wo-empty-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="38" stroke="#E0E0E0" stroke-width="4" fill="#F8F9FA"/>
                <path d="M25 50L55 50" stroke="#B0B0B0" stroke-width="3" stroke-linecap="round"/>
                <rect x="30" y="30" width="20" height="10" rx="2" fill="#E0E0E0"/>
                <circle cx="40" cy="45" r="2" fill="#B0B0B0"/>
            </svg>
        </div>
        <div class="wo-empty-message">
            <h3>{{ 'Reports.NoDataToDisplay' | translate }}</h3>
            <p>{{ 'Reports.NoDataToDisplayMessage' | translate }}</p>
        </div>
    </div>
</section>